var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg4Pin = function Svg4Pin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 12,
    viewBox: "0 0 111 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17313",
    "data-name": "Group 17313",
    transform: "translate(-81.352 -529)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1019",
    "data-name": "Ellipse 1019",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(81.352 529)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1020",
    "data-name": "Ellipse 1020",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(114.352 529)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1021",
    "data-name": "Ellipse 1021",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(147.352 529)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1022",
    "data-name": "Ellipse 1022",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(180.352 529)",
    fill: "#07a3c8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4Pin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4Pin.f77f1139.svg";
export { ForwardRef as ReactComponent };